import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "c-burgermenu" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "page__title" }
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = { class: "page__image-title" }
const _hoisted_8 = ["src"]

import { computed } from "vue";
import { useStore } from "vuex";

//Icons
import ChevronIcon from "@web/assets/icon/chevron.svg";
import SeeAllIcon from "@web/assets/icon/union.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'Burgermenu',
  props: {
	navPages: {
		type: Array,
	},
	currentParent: {
		type: String,
	},
	currentViewLevel: {
		type: Number,
		default: 1,
	},
	currentViewPages: {
		type: Array,
		default: [],
	},
},
  emits: ["navigateForward"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const translations = computed(() => store.state.translations.siteTranslations);

// Define emit
const emit = __emit;

const props = __props;

function setCurrentPagesLevel(page: Object) {
	// If level is empty, do not toggle the view
	if (!page.menuItems.length) {
		return;
	}

	// Toggle view
	emit("navigateForward", page.menuItems, page.url);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.currentViewLevel <= 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navPages, (navpage) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["c-burgermenu__level1 page", __props.currentViewLevel > 1 ? 'c-burgermenu__level1--hidden' : '']),
              href: !navpage.menuItems.length ? navpage.url : '#',
              onClick: ($event: any) => (setCurrentPagesLevel(navpage))
            }, [
              _createTextVNode(_toDisplayString(navpage.title) + " ", 1),
              (navpage.menuItems.length)
                ? (_openBlock(), _createBlock(_unref(ChevronIcon), { key: 0 }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["c-burgermenu__nested-pages", __props.currentViewLevel > 1 ? 'c-burgermenu__nested-pages--visible' : ''])
    }, [
      (__props.currentViewLevel > 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "page see-all",
            href: __props.currentParent
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(translations.value["seeAll"]), 1),
            _createVNode(_unref(SeeAllIcon))
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentViewPages, (page) => {
        return (_openBlock(), _createElementBlock("a", {
          href: !page.menuItems.length ? page.url : '#',
          class: "page",
          onClick: ($event: any) => (setCurrentPagesLevel(page))
        }, [
          _createElementVNode("div", _hoisted_7, [
            (page.iconUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: page.iconUrl
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(page.title), 1)
          ]),
          (page.menuItems.length)
            ? (_openBlock(), _createBlock(_unref(ChevronIcon), { key: 0 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_6))
      }), 256))
    ], 2)
  ]))
}
}

})